import { heroStats } from "@/mocks/loveHelperData";

export default function Hero() {
  return (
    <section
      id="home"
      className="relative flex min-h-[680px] w-full flex-col items-center justify-center overflow-hidden bg-cover bg-center px-4 pt-24 text-center md:min-h-[720px]"
      style={{
        backgroundImage:
          "url(https://lovelinez.github.io/api/search-image?query=soft%20dreamy%20anime%20background%20with%20pink%20cherry%20blossoms%20floating%20in%20warm%20cream%20sky%2C%20stylized%20minimal%20pastel%20illustration%2C%20gentle%20bokeh%20and%20light%20particles%2C%20romantic%20youthful%20atmosphere%2C%20clean%20flat%20art%20style&width=1600&height=900&seq=hero-lovehelper&orientation=landscape)",
      }}
    >
      <div className="absolute inset-0 bg-gradient-to-b from-black/20 via-black/10 to-background-50"></div>

      <div className="relative z-10 mx-auto flex w-full max-w-4xl flex-col items-center">
        <span className="mb-6 inline-flex items-center gap-2 rounded-full bg-background-50/80 px-4 py-1.5 text-sm font-medium text-primary-700 backdrop-blur">
          <i className="ri-sparkling-2-fill text-primary-500"></i>
          恋爱辅助器漫画 · 角色与感情线解析站
        </span>

        <h1 className="font-display text-4xl leading-tight text-background-50 drop-shadow-lg md:text-6xl">
          恋爱辅助器漫画
        </h1>
        <p className="mt-5 max-w-2xl text-base leading-relaxed text-background-50/95 drop-shadow md:text-lg">
          一部少女心满满的青春恋爱漫画。这里为你完整梳理
          <strong className="font-semibold">恋爱辅助器漫画角色</strong>、追
          <strong className="font-semibold">恋爱辅助器CP</strong>、拆解
          <strong className="font-semibold">恋爱辅助器感情线</strong>，
          从男主女主到白月光与竹马，人物关系一目了然。
        </p>

        <div className="mt-8 flex flex-col gap-3 sm:flex-row">
          <a
            href="#characters"
            className="whitespace-nowrap rounded-full bg-primary-500 px-7 py-3.5 text-sm font-semibold text-background-50 transition-all hover:-translate-y-0.5 hover:bg-primary-600"
          >
            看角色图鉴
          </a>
          <a
            href="#timeline"
            className="whitespace-nowrap rounded-full bg-background-50/20 px-7 py-3.5 text-sm font-semibold text-background-50 backdrop-blur transition-all hover:-translate-y-0.5 hover:bg-background-50/30"
          >
            感情线全解析
          </a>
        </div>
      </div>

      <div className="relative z-10 mt-12 grid w-full max-w-4xl grid-cols-2 gap-3 px-4 sm:grid-cols-4 md:gap-4">
        {heroStats.map((s) => (
          <div
            key={s.label}
            className="rounded-lg bg-background-50/85 px-4 py-5 text-center backdrop-blur"
          >
            <p className="font-display text-2xl text-primary-600">{s.num}</p>
            <p className="mt-1 text-sm text-foreground-600">{s.label}</p>
          </div>
        ))}
      </div>
    </section>
  );
}